import * as actionTypes from '../types/inputOperation';

const initialState = {
  operationMaterials: [],
  error: false,
  loading: false,
  okRequest: false,
  getOperation: {
    loading: false,
    okRequest: false
  },
  saveOperation: {
    loading: false,
    okRequest: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_OPERATION:
      return {
        ...state,
        loading: true,
        getOperation: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_OPERATION_SUCCESS:
      return {
        ...state,
        operationMaterials: payload.operationPieceAllWasteGetDtos
          ? {
            ...payload,
            operationPieces: payload.operationPieceAllWasteGetDtos
          }
          : payload,
        okRequest: true,
        loading: false,
        getOperation: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        getOperation: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.SAVE_OPERATION:
      return {
        ...state,
        loading: true,
        error: false,
        saveOperation: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.SAVE_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        operationMaterials: payload,
        saveOperation: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.SAVE_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        saveOperation: {
          loading: false,
          okRequest: false
        }
      };
    default:
      return state;
  }
};

export default reducer;
